import { RECEIVE_NEWS_DATA } from "../actions/newsActions";

const initialState = {};

export default function newsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_NEWS_DATA:
      return {
        ...state,
        news: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/newsReducer.js